//    $$$$$$$\   $$$$$$\   $$$$$$\  $$\   $$\
//    $$  __$$\ $$  __$$\ $$  __$$\ $$ | $$  |
//    $$ |  $$ |$$ /  $$ |$$ /  \__|$$ |$$  /
//    $$$$$$$  |$$ |  $$ |$$ |      $$$$$  /
//    $$  __$$< $$ |  $$ |$$ |      $$  $$<
//    $$ |  $$ |$$ |  $$ |$$ |  $$\ $$ |\$$\
//    $$ |  $$ | $$$$$$  |\$$$$$$  |$$ | \$$\
//    \__|  \__| \______/  \______/ \__|  \__|

//    $$\       $$$$$$\ $$$$$$$$\ $$$$$$\ $$$$$$$$\ $$$$$$$$\
//    $$ |      \_$$  _|\__$$  __|\_$$  _|\__$$  __|\____$$  |
//    $$ |        $$ |     $$ |     $$ |     $$ |       $$  /
//    $$ |        $$ |     $$ |     $$ |     $$ |      $$  /
//    $$ |        $$ |     $$ |     $$ |     $$ |     $$  /       ! ! !
//    $$ |        $$ |     $$ |     $$ |     $$ |    $$  /
//    $$$$$$$$\ $$$$$$\    $$ |   $$$$$$\    $$ |   $$$$$$$$\
//    \________|\______|   \__|   \______|   \__|   \________|


import React from 'react';
import Loadable from 'react-loadable';
import Loading from 'Core/Status/LoadingView';
import { Route, BrowserRouter, browserHistory, Switch } from 'react-router-dom';
import RLX from 'RLX';
import Site from 'Site';

class Root extends React.Component {
  render () {
    return (
      <BrowserRouter history={browserHistory}>
        <Switch>
          <Route path="/RLX" component={RLX} />
          <Route path="/" component={Site} />
        </Switch>
      </BrowserRouter>
    );
  }
};

export default Root;



// WEBPACK FOOTER //
// ./client/Core/Root.jsx